import React from 'react';

interface SearchModeSelectorProps {
  searchMode: 'ai' | 'code' | 'map';
  setSearchMode: (mode: 'ai' | 'code' | 'map') => void;
}

export const SearchModeSelector: React.FC<SearchModeSelectorProps> = ({
  searchMode,
  setSearchMode,
}) => {
  const options: Array<{ id: 'ai' | 'code' | 'map'; label: string }> = [
    { id: 'ai', label: 'Palabras clave' },
    { id: 'code', label: 'Código(s)' },
    { id: 'map', label: 'Mapa o dirección' },
  ];

  return (
    <div className="inline-flex items-center p-1 bg-gray-100 rounded-xl border border-gray-200/80 mb-4 shadow-inner">
      {options.map((opt, idx) => {
        const isSelected = searchMode === opt.id;
        const prevIsSelected = idx > 0 && searchMode === options[idx - 1].id;
        const showDivider = idx > 0 && !isSelected && !prevIsSelected;

        return (
          <React.Fragment key={opt.id}>
            {showDivider && (
              <div className="h-4 w-[1px] bg-gray-300 mx-1" />
            )}
            <button
              type="button"
              onClick={() => setSearchMode(opt.id)}
              className={`px-4 py-1.5 rounded-lg text-xs md:text-sm font-semibold transition-all duration-200 flex items-center gap-2 select-none ${
                isSelected
                  ? 'bg-gray-800 text-white shadow-sm'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-200/60'
              }`}
            >
              <span>{opt.label}</span>
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
};
